export default __webpack_public_path__ + "static/media/02_DAIF_Services_02_loop.a51e4542.mp4";